import { ref } from "vue";

export function useFileDownloader() {
  const isDownloading = ref(false);
  const error = ref<string>("");

  async function downloadFile(url: string, filename: string) {
    isDownloading.value = true;
    error.value = "";

    try {
      const response = await fetch(url);

      if (response.status != 200) {
        // Try to parse error message from backend
        let message = `Download failed: ${response.status} ${response.statusText}`;
        try {
          const data = await response.json();
          if (data.detail) {
            message = data.detail;
          }
        } catch (e) {
          // Ignore JSON parsing errors, fallback to default message
        }
        error.value = message;
        return;
      }

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      a.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (err: any) {
      error.value = err.message || "Unknown error during download.";
    } finally {
      isDownloading.value = false;
    }
  }

  return {
    isDownloading,
    error,
    downloadFile,
  };
}
